import React from 'react';
import PropTypes from 'prop-types';

import { CURRENCY } from '../../../../../../constants/currency';
import PriceBreakdownList from '../../../../../checkout/components/PriceBreakdownList';
import DismissButton from '../../../../../../components/global/DismissButton';
import Button from '../../../../../../components/global/Button';
import { ACCOUNT_REFERRAL_TYPE } from '../../../../../../constants/account-referrals';
import useVirtualPageView from '../../../../../../apps/pro/services/analytics/useVirtualPageView';
import { STRIPE_CHECKOUT_MODAL } from '../../../../../../components/global/StripeCheckout';
import useOpenModal from '../../../../../../hooks/useOpenModal';

const propTypes = {
  pricing: PropTypes.shape({
    total_price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_shipping_cost: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_tax: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
  }),
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCheckout: PropTypes.func.isRequired,
  loadingPricing: PropTypes.bool,
  defaultPromoCode: PropTypes.string,
  accountCardCheckoutInput: PropTypes.object.isRequired,
};

const AccountCardCheckoutPayment = ({
  loadingPricing,
  pricing,
  onClose,
  submitting,
  onCheckout,
  defaultPromoCode,
  accountCardCheckoutInput,
}) => {
  const openModal = useOpenModal();
  useVirtualPageView({
    title: 'Create a card - Payment',
    path: '/payment',
  });

  return (
    <div className="modal-contained-wrap">
      <div className="modal-contained-header">
        <DismissButton onClick={onClose} />

        <span className="modal-contained-title">Checkout</span>
      </div>

      <div className="modal-contained-content">
        <div className="p-2">
          <h4 className="mb-1 text-extra-bold text-faded">Total</h4>
          <PriceBreakdownList pricing={pricing} className="mb-3" />
        </div>
      </div>

      <div className="modal-contained-footer account-card-checkout-payment-sticky-footer">
        <div className="p-2">
          <Button
            disabled={submitting || loadingPricing}
            btnBlock
            btnSize="lg"
            className="btn-round"
            onClick={() => {
              openModal(STRIPE_CHECKOUT_MODAL, {
                buttonLabel: 'Send card',
                cardRequired: false,
                onSuccess: token => onCheckout(token),
                accountReferralTypes: [
                  ACCOUNT_REFERRAL_TYPE.WALDOGRAM_PROMO,
                  ACCOUNT_REFERRAL_TYPE.TIER_1_WALDOGRAM_PROMO,
                  ACCOUNT_REFERRAL_TYPE.ONE_FREE_WALDOGRAM,
                ],
                defaultPromoCode,
                checkoutPriceVariables: ({ promo_code: promoCode }) => {
                  return {
                    ...accountCardCheckoutInput,
                    promo_code: promoCode,
                  };
                },
              });
            }}
          >
            {submitting ? 'Loading...' : 'Send card'}
          </Button>
        </div>
      </div>
    </div>
  );
};

AccountCardCheckoutPayment.propTypes = propTypes;

export default AccountCardCheckoutPayment;
